module.exports = __webpack_public_path__ + "static/media/LASER-CUTTING.4f38f098.png";